const PREVIEW_SIZE = 30;
const PREVIEW_PADDING = 4;
const IDLE_ROTATION = 'rotate(20deg)';

/**
 * Where the dragged device currently is, ported from the legacy planner's
 * #dnd-helper-icon: outside the canvas (tilted blue), inside a floor where it
 * can be dropped (straightened blue), or over the canvas but outside any
 * droppable floor area (red).
 */
export enum DragPreviewState {
    OUTSIDE_CANVAS = 'outside_canvas',
    INSIDE_FLOOR = 'inside_floor',
    OUTSIDE_FLOOR = 'outside_floor',
}

let activePreview: HTMLImageElement | null = null;

export function createDragPreview(icon: string): HTMLImageElement {
    const img = document.createElement('img');
    img.src = icon;
    img.style.position = 'fixed';
    img.style.pointerEvents = 'none';
    img.style.zIndex = '10000';
    img.style.width = `${PREVIEW_SIZE}px`;
    img.style.height = `${PREVIEW_SIZE}px`;
    img.style.boxSizing = 'content-box';
    img.style.padding = `${PREVIEW_PADDING}px`;
    img.style.objectFit = 'contain';
    img.style.borderRadius = '8px';
    img.style.boxShadow = '0 2px 6px rgba(0,0,0,0.25)';
    img.style.transformOrigin = 'center';
    document.body.appendChild(img);
    activePreview = img;
    setDragPreviewState(img, DragPreviewState.OUTSIDE_CANVAS);
    return img;
}

export function updateDragPreview(preview: HTMLImageElement, x: number, y: number) {
    preview.style.left = `${x - PREVIEW_SIZE / 2}px`;
    preview.style.top = `${y - PREVIEW_SIZE / 2}px`;
}

export function setGrabbingCursor(on: boolean) {
    document.documentElement.style.cursor = on ? 'grabbing' : '';
}

export function refreshDragPreviewState(preview: HTMLImageElement) {
    const overPlanner = !!document.querySelector('#plannerSVG:hover');
    if (!overPlanner) {
        setDragPreviewState(preview, DragPreviewState.OUTSIDE_CANVAS);
    }
}

export function setDragPreviewState(preview: HTMLImageElement, state: DragPreviewState) {
    switch (state) {
        case DragPreviewState.OUTSIDE_FLOOR:
            preview.style.background = 'rgba(255, 0, 0, 0.35)';
            preview.style.border = '1px solid rgba(150, 0, 0, 0.85)';
            preview.style.transform = 'rotate(0deg)';
            break;
        case DragPreviewState.INSIDE_FLOOR:
            preview.style.background = 'var(--uplan-blue-lighter-2)';
            preview.style.border = '1px solid var(--uplan-blue-darker-4)';
            preview.style.transform = 'rotate(0deg)';
            break;
        case DragPreviewState.OUTSIDE_CANVAS:
            preview.style.background = 'var(--uplan-blue-lighter-2)';
            preview.style.border = '1px solid var(--uplan-blue-darker-4)';
            preview.style.transform = IDLE_ROTATION;
            break;
    }
}

export function setActiveDragPreviewState(state: DragPreviewState) {
    if (activePreview) {
        setDragPreviewState(activePreview, state);
    }
}

export function removeDragPreview(preview: HTMLImageElement | null) {
    if (preview) {
        preview.remove();
        if (preview === activePreview) {
            activePreview = null;
        }
    }
}
